import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  TemplateRef,
} from '@angular/core';
import { Drawer, DrawerModule } from '@openng/optimus-ui/drawer';

@Component({
  selector: 'ui-bottom-sheet',
  imports: [Drawer, DrawerModule, NgTemplateOutlet],
  standalone: true,
  templateUrl: './ui-bottom-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiBottomSheetComponent {
  readonly headerTemplate = input<TemplateRef<unknown> | null>(null);

  readonly visible = signal(false);

  show(): void {
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }
}
